import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ServicesMenuHarmonySmallIcon extends BaseIcon {
  getChildren = () => [
    <path fill="#e45785"
          d="M15.8 5c-.1 0-.1 0 0 0-.1 0-1.8.1-3.6.5.6 1.4 1 2.9 1 4.5 0 1.5-.3 2.6-.7 3.5C16 10.6 16 5.4 16 5.2c0-.1-.1-.2-.2-.2z"/>,
    <path d="M8.1 1c-.7.8-4 4.7-4 9 0 4.8 3.6 5 4 5 .9 0 4-.4 4-5 0-4.2-3.3-8.2-4-9z" fill="#8c00ff"/>,
    <path
        d="M8.3 15h.1c.3 0 .8-.2 1.3-.5l.4-.4c.4-.5 2.4-3.2-.8-6.9-.3-.4-.8-.8-1.2-1.2L6.9 7.2C4 10.6 5.5 13.2 6 14c.6.7 1.4.9 1.8 1h.5c-.1 0-.1 0 0 0z"
        fill="#700046"/>,
    <path fill="#e45785"
          d="M3.1 10c0-1.6.4-3.1 1-4.5C2.1 5.1.4 5 .3 5c-.2 0-.3.1-.3.2 0 .2 0 5.8 4.1 8.6-.6-.8-1-2.1-1-3.8z"/>
  ]
  getViewBox = () => '0 0 16 16'
}
